<template>

    <div class="page">
        <div class="page-frame" v-if="emailVerified">
            <header>
                <h1>Dashboard</h1>
            </header>
        </div>
        
        <div class="job-board-container-wrapper" v-if="emailVerified">
            <div class="page-frame">
                <div class="job-board-container">
                    <div class="job-board" v-if="jobs.length > 0">
                        <JobBoardListItemPrivate
                            v-for="job in jobs"
                            :key="job.id"
                            :uid ="job.id"
                            :logo="job.logoData"
                            :title="job.title"
                            :company="job.company"
                            :city="job.city"
                            :state="job.state"
                            :type="job.type"
                            :tags="job.tags"
                            :expires="job.expires"
                            :created="job.created"
                            :remote="job.remote"
                        ></JobBoardListItemPrivate>
                    </div>
                    <div v-else class="nojobs-wrapper">
                        <div class="nojobs">
                            <p>No jobs found.</p>
                            <Btn route to="/dashboard/add">Post a Job</Btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-frame page-frame-small" v-else >
            <h1>Dashboard</h1>
            <div v-if="!emailVerified">Check your inbox for verification email. <a @click="verifyEmail">Resend Confirmation Email</a></div>
        </div>
    </div>
</template>
<script>
    import firebase from "firebase/app"
    import "firebase/firestore";
    import Btn from '@/components/Btn.vue'

    import JobBoardListItemPrivate from '@/components/JobBoardListItemPrivate.vue'
    
    export default {
        name: "dashboard",
        data: () => ({
            emailVerified: false,
            jobs: []
        }),
        components: {
            JobBoardListItemPrivate,
            Btn
        },
        methods: {
            verifyEmail () {
                firebase.auth().currentUser.sendEmailVerification()
                    
            },
            logout(){
                this.$store.dispatch('signOut').then(() => this.$router.replace('/'))
            }
        },
        beforeMount(){
            this.emailVerified = firebase.auth().currentUser.emailVerified;
        },
        mounted () {
            if (this.emailVerified) {
                this.$store.dispatch( 'getMyJobs', this.email ).then( jobs => this.jobs = jobs )
            }
        },
        computed: {
            email () {
                return this.$store.state.email
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";

    header{
        display: flex;
        justify-content: space-between;
    }
    .nojobs-wrapper {
        margin: 0 auto;
    }

    .nojobs {
        margin: 2rem 0;
        background-color: white;
        padding: 1rem 4rem;
        text-align: center;
    }

    .job-board{
        // padding: 0.5rem 1.25rem;
        
        @media screen and (min-width: $b1){
            flex-grow: 1;
        }
    }
    .job-board-container{
        z-index: 100;
        position: relative;
        border-radius: $radius;

        @media screen and (min-width: $b1){
            display: flex;
        }

        &-wrapper{
            padding: 1rem;
            background-color: #e9e9e9;
        }
    }

    .page-frame{
        max-width: 900px;
        margin: 0 auto;

        .small{
            max-width: 500px;
        }
    }
</style>